export enum CustomerCardState {
    SEARCH = 'SEARCH',
    DETAILS = 'DETAILS',
    EDIT = 'EDIT',
    INBOX = 'INBOX',
    LOADING = 'LOADING',
    CLOSE = 'CLOSE'
}
export const FINANCING_TITLE = 'Customer Details';
